function getPropByPath(obj) {
  let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let strict = arguments.length > 2 ? arguments[2] : undefined;
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');
  const keyArr = path.split('.');
  let idx = 0;
  for (let len = keyArr.length; idx < len - 1; ++idx) {
    if (!tempObj && !strict) {
      break;
    }
    const key = keyArr[idx];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    obj: tempObj,
    key: keyArr[idx],
    value: tempObj ? tempObj[keyArr[idx]] : null
  };
}
function getRuleForTrigger(rules, trigger) {
  return rules.filter(rule => {
    if (!rule.trigger || trigger === '') {
      return true;
    }
    if (Array.isArray(rule.trigger)) {
      return rule.trigger.indexOf(trigger) > -1;
    }
    return rule.trigger === trigger;
  }).map(rule => Object.assign({}, rule));
}
function noop() {}

export { getPropByPath, getRuleForTrigger, noop };
//# sourceMappingURL=utils.js.map
